// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2fJqO","balanceDisclaimer":"posDashboard_balanceDisclaimer__3MWSd"};